// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__26BkN","noTransiton":"Layout_noTransiton__3XQvk"};